import styled from 'styled-components';

//helpers
import {borderRadius, cardShadowCss} from 'styles/vars';

//components
import {StepContentMobile} from 'components/StepContent';
import $StepMedia from './StepMedia';

export const StepSlide = styled.div`
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  .stepNumber {
    left: 0;
    top: ${p => (p.hasReportButton ? '4rem' : '2rem')};
    transform: translateX(-50%);
  }
`;
export const StepCard = styled.div`
  ${cardShadowCss(false)};
  background: #fff;
  border-radius: ${borderRadius.mobile}px;
  display: flex;
  flex-direction: ${p => (p.orientation === 'portrait' ? 'column-reverse' : 'row')};
  height: 100%;
`;

export const Left = styled.div`
  display: flex;
  flex-basis: 0; // IE11
  flex-direction: column;
  flex-grow: 1;
  flex-shrink: 1;
  min-height: 0;
  position: relative;
`;

export const Right = styled.div`
  position: relative;

  ${p =>
    p.orientation === 'landscape' &&
    `
    height: 100%;
    width: 50%;
  `}

  ${p =>
    p.orientation === 'portrait' &&
    `
    width: 100%;

    &::before {
      content: '';
      display: block;
      padding-top: 75%;
    }
  `}
`;

export const StepContent = styled(StepContentMobile)`
  flex: 1;
`;

export const StepMedia = styled($StepMedia)`
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
`;

export const FadeOutIconsWrapper = styled.div`
  margin: 0 0 10px 15px;
`;
